<template>
  <div class="App-Streamer bg-black">
    <div class="inner">
      <h1 class="h1 title text-center text-white">{{ $t('streamer.title') }}</h1>
      <div class="content text-white">
        <streamer></streamer>
      </div>
    </div>
  </div>
</template>

<script>
  import { META_STREAMER } from '../../mixins/metadata.js'
  import Streamer from './component/streamer.vue'

  export default {
    mixins: [META_STREAMER],
    components: {
      'streamer': Streamer,
    },
    name: 'StreamerPage',
    head: {
      title: {
        inner: '配信者一覧｜ZATSUDAN'
      },
      meta: [
        { name: 'keywords', content: '思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談' },
        { name: 'description', content: '思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談' },
      ]
    },
  }
</script>
